"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _date = require("../../../../utils/date/date");
var _excluded = ["format"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TIME_FORMAT_DEFAULT = "H:mm \u22C5 d MMMM, EEEEEE"; // Пример: 15:21 ⋅ 4 февраля, пн.
var UPDATE_INTERVAL_DEFAULT = 60 * 1000;
var Time = /*#__PURE__*/function (_React$PureComponent) {
  function Time(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Time);
    _this = _callSuper(this, Time, [props]);
    _this.update = _this.update.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(Time, _React$PureComponent);
  return (0, _createClass2["default"])(Time, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var updateInterval = this.props.updateInterval;
      this.interval = setInterval(this.update, updateInterval);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "update",
    value: function update() {
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        format = _this$props.format,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var today = new Date();
      var formattedDate = (0, _date.formatDate)(today, format);
      return /*#__PURE__*/_react["default"].createElement(StyledTime, props, formattedDate);
    }
  }]);
}(_react["default"].PureComponent);
Time.propTypes = {
  className: _propTypes["default"].string,
  format: _propTypes["default"].string,
  updateInterval: _propTypes["default"].number
};
Time.defaultProps = {
  className: '',
  format: TIME_FORMAT_DEFAULT,
  updateInterval: UPDATE_INTERVAL_DEFAULT
};
var StyledTime = _styledComponents["default"].div.withConfig({
  displayName: "Time__StyledTime",
  componentId: "sc-q9yghr-0"
})(["font-size:12px;"]);
var _default = exports["default"] = Time;